var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9162_37526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 11.668H5C5.45833 11.668 5.83333 11.293 5.83333 10.8346V9.16797C5.83333 8.70964 5.45833 8.33464 5 8.33464H3.33333C2.875 8.33464 2.5 8.70964 2.5 9.16797V10.8346C2.5 11.293 2.875 11.668 3.33333 11.668ZM3.33333 15.8346H5C5.45833 15.8346 5.83333 15.4596 5.83333 15.0013V13.3346C5.83333 12.8763 5.45833 12.5013 5 12.5013H3.33333C2.875 12.5013 2.5 12.8763 2.5 13.3346V15.0013C2.5 15.4596 2.875 15.8346 3.33333 15.8346ZM3.33333 7.5013H5C5.45833 7.5013 5.83333 7.1263 5.83333 6.66797V5.0013C5.83333 4.54297 5.45833 4.16797 5 4.16797H3.33333C2.875 4.16797 2.5 4.54297 2.5 5.0013V6.66797C2.5 7.1263 2.875 7.5013 3.33333 7.5013ZM7.5 11.668H16.6667C17.125 11.668 17.5 11.293 17.5 10.8346V9.16797C17.5 8.70964 17.125 8.33464 16.6667 8.33464H7.5C7.04167 8.33464 6.66667 8.70964 6.66667 9.16797V10.8346C6.66667 11.293 7.04167 11.668 7.5 11.668ZM7.5 15.8346H16.6667C17.125 15.8346 17.5 15.4596 17.5 15.0013V13.3346C17.5 12.8763 17.125 12.5013 16.6667 12.5013H7.5C7.04167 12.5013 6.66667 12.8763 6.66667 13.3346V15.0013C6.66667 15.4596 7.04167 15.8346 7.5 15.8346ZM6.66667 5.0013V6.66797C6.66667 7.1263 7.04167 7.5013 7.5 7.5013H16.6667C17.125 7.5013 17.5 7.1263 17.5 6.66797V5.0013C17.5 4.54297 17.125 4.16797 16.6667 4.16797H7.5C7.04167 4.16797 6.66667 4.54297 6.66667 5.0013Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9162_37526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/List.0293bc1e7057ad57d20138522b01fb3c.svg";
export { ForwardRef as ReactComponent };